import React from 'react';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { MyTableCell1 } from '../../../../styling/Styles';
import apiService from '../../../../services/apiService';


// This component renders the cell of the row that is responsible for name info
const NameCell = ({ row, index, showStatus, projectRole, setDisplayKickedOutMessage }) => {
  const navigate = useNavigate();

  /**
   * When user clicks in name cell then it should go to page buil_apps.
   * We give as args to state the name of the project and we set selectedPage
   * as -1, which means that we do not want to open a specific page when we
   * go to build apps.
   */
  const moveBuildApps = (project) => {

    if(projectRole === 'owner'){
      localStorage.setItem('current_project', JSON.stringify(project));
      navigate('/build_apps', { state: { name: project.name, selectedPage: -1 } });
    }
    else if(projectRole === 'member'){
      apiService
        .getUserField('memberOfProjects')
        .then( (response) => {
          if(response.data.includes(project._id) === true){
            localStorage.setItem('current_project', JSON.stringify(project));
            navigate('/build_apps', { state: { name: project.name, selectedPage: -1 } });
          }
          else{
            setDisplayKickedOutMessage(true);
          }
        })
    }

    

    
  };

  return (
    <MyTableCell1
      id={`nameCell${row.name}`}
      scope="row"
      padding="none"
      align="center"
      onClick={showStatus === true ? () => moveBuildApps(row) : null}
      className={showStatus === true ? clsx('teamSelector') : null}
      style={index % 2 === 0 ? null : { backgroundColor: '#CFD8E0' }}
    >
      <span style={showStatus === false ? { color: '#999999' } : null}>{row.name}</span>
    </MyTableCell1>
  );
};

export default NameCell;
